import styled from 'styled-components'

import { ellipsis } from '@avantstay/backoffice-core'

import { COLORS } from '../../DataGrid.theme'
import { FilterIndicatorContainer } from '../FilterIndicator'
import { SortColumnWrapper } from '../SortColumnIndicator'

export const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-column-gap: 6px 4px;
  align-items: center;
  height: 100%;
  width: 100%;

  &:hover {
    ${SortColumnWrapper} {
      display: flex;
    }
    ${FilterIndicatorContainer} {
      display: flex;
    }
  }
`

export const PinnedIndicator = styled.div<{ $active: boolean }>`
  color: ${({ $active }) => ($active ? COLORS.accentMedium : COLORS.neutralDark)};

  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${COLORS.neutralExtremelyDark};
  }
`

export const EllipsisContainer = styled.div`
  ${ellipsis};
`
